import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

const featureOptions = [
  { id: "vision-panels", name: "Vision Panels", desc: "Clear window inserts for visibility through walls/curtains" },
  { id: "floor-sweep", name: "Floor Sweep Seal", desc: "Bottom seal to prevent dust and debris passing underneath" },
  { id: "overlap-strips", name: "Overlap Strips", desc: "Overlapping material at joins for better sealing" },
  { id: "uv-stabilisation", name: "UV Stabilisation", desc: "Enhanced UV protection for outdoor or sun-exposed areas" },
  { id: "dust-proof-sealing", name: "Dust-Proof Sealing", desc: "Full perimeter sealing to contain or exclude dust" },
  { id: "anchor-straps", name: "Anchor Straps", desc: "Tie-down straps to secure curtains against wind or movement" },
];

const entryOptions = [
  { id: "none", name: "None" },
  { id: "strip-door", name: "Strip Door" },
  { id: "swing-door", name: "Swing Door" },
  { id: "roll-up", name: "Roll-Up Door" },
];

export default function StepFeatures({ form, setForm }) {
  const toggleFeature = (fId) => {
    setForm((prev) => ({
      ...prev,
      features: prev.features.includes(fId)
        ? prev.features.filter((f) => f !== fId)
        : [...prev.features, fId],
    }));
  };

  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Features & Add-ons
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Toggle any additional features you'd like included.</p>

      {/* Feature toggles */}
      <div className="space-y-4 mb-10 max-w-2xl">
        {featureOptions.map((f) => {
          const active = form.features.includes(f.id);
          return (
            <div
              key={f.id}
              className={`flex items-center justify-between p-4 border transition-all duration-200 ${
                active ? "border-[#FF5722] bg-[#FF5722]/5" : "border-[#2E2E2E] bg-[#141414]"
              }`}
            >
              <div className="flex-1 mr-4">
                <p className={`font-bold text-sm ${active ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                  {f.name}
                </p>
                <p className="text-xs text-[#A3A3A3] mt-0.5">{f.desc}</p>
              </div>
              <Switch
                data-testid={`feature-${f.id}`}
                checked={active}
                onCheckedChange={() => toggleFeature(f.id)}
                className="data-[state=checked]:bg-[#FF5722]"
              />
            </div>
          );
        })}
      </div>

      {/* Entry Point */}
      <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
        Entry Point
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-xl">
        {entryOptions.map((e) => {
          const selected = form.entry_point === e.id;
          return (
            <button
              key={e.id}
              type="button"
              data-testid={`entry-${e.id}`}
              onClick={() => setForm((prev) => ({ ...prev, entry_point: e.id }))}
              className={`text-center p-3 border text-sm font-medium transition-all duration-200 ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5 text-[#FF5722]"
                  : "border-[#2E2E2E] bg-[#141414] text-[#A3A3A3] hover:border-[#FF5722]/50"
              }`}
            >
              {e.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
